import { NetworkStatus, useSuspenseQuery } from '@apollo/client';

import { EntityPagesAboutQueryDocument } from '../graphql/queries/entity-pages-about-query.gql-types';

type UseAboutQuery = {
  failed: boolean;
  loading: boolean;
  refetch: () => void;
  summary: string;
};

export const useAboutQuerySuspense = (pageSlug: string): UseAboutQuery => {
  const { data, error, networkStatus, refetch } = useSuspenseQuery(
    EntityPagesAboutQueryDocument,
    {
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      variables: { id: pageSlug },
    }
  );

  const summary =
    data?.pagesAboutUs?.__typename === 'AboutEntity' &&
    data.pagesAboutUs.summary
      ? data.pagesAboutUs.summary
      : '';

  const failed =
    !!error || data?.pagesAboutUs?.__typename === 'EntityPageError';

  return {
    failed,
    loading: networkStatus === NetworkStatus.refetch,
    refetch: () => refetch({ id: pageSlug }),
    summary,
  };
};
